<template>
	<div class="yxtInfo" >
		<div class="content flex-row" >
			<div class="left">
				<div class="title">药销通，协助您真实合规！</div>
				<div class="textInfo">咨询热线：400—901—3689转1</div>
				<div class="textInfo">合作专线：186 6012 2326</div>
				<el-button @click="toOpen">联系我们</el-button>
			</div>
			<div class="right">
				<div class="form">
					<el-form ref="form" :rules="rules" :model="form" label-width="0px" size="mini">
						<el-form-item>
							<div class="form-title-one">提交申请，即刻获取专家1对1服务</div>
							<div class="form-title-two">独家定制企业营销合规全链解决方案</div>
						</el-form-item>
						<div class="flex-row form1">
							<el-form-item prop="contacts"><el-input placeholder="联系人" v-model="form.contacts"></el-input></el-form-item>
							<el-form-item prop="tel"><el-input placeholder="手机号" v-model="form.tel"></el-input></el-form-item>
						</div>
						<el-form-item prop="enterpriseName"><el-input placeholder="企业名称" v-model="form.enterpriseName"></el-input></el-form-item>
						<el-form-item label-width="150" label="企业类型">
							<div class="radio">
								<el-radio v-model="form.type" label="1">服务商</el-radio>
								<el-radio v-model="form.type" label="2">药企</el-radio>
							</div></el-form-item>
						<el-form-item prop="phone"><el-input placeholder="您所在公司职务" v-model="form.job" maxlength="11"></el-input></el-form-item>
						<el-form-item><el-input placeholder="您的需求" type="textarea" v-model="form.yourRequirements" :rows="4" resize="none"></el-input></el-form-item>
						<div class="flex-row form1">
							<el-form-item prop="verificationCode"><el-input placeholder="验证码" v-model="form.verificationCode"></el-input></el-form-item>
							<el-form-item>
								<div @click="refreshCode" class=" verificationCode flex-row flex-center">
									<verification-code :canvasId="canvasId" :identifyCode="identifyCode"></verification-code>
								</div>
							</el-form-item>
						</div>
						<el-form-item><p>*我们将于1个工作日内与您取得联系</p></el-form-item>
						<el-form-item><el-button @click="onSubmit">免费体验</el-button></el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { WOW } from 'wowjs';
import { addapply } from '@/api/addapply/addapply.js';
import VerificationCode from '../../freeTrial/components/verificationCode.vue';
export default {
	components: { VerificationCode },
	mounted() {
		this.refreshCode();
		this.$nextTick(() => {
			// 在dom渲染完后,再执行动画
			var wow = new WOW({
				live: false,
				offset: 100
			});
			wow.init();
		});
	},
	beforeDestroy() {
	},
	methods: {
		toOpen() {
			this.$router.push('/freeTrial');
		},
		onSubmit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					addapply(this.form).then(({ data: res }) => {
						if (res.data) {
							this.$message({
								message: '恭喜你，申请成功，稍后会有专人与您联系',
								type: 'success'
							});
							this.refreshCode();
						}else{
							this.$message({
								message: res.msg,
								type: 'warning'
							});
						}
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}, // 生成随机数
		randomNum(min, max) {
			max = max + 1;
			return Math.floor(Math.random() * (max - min) + min);
		},
		// 更新验证码
		refreshCode() {
			this.identifyCode = '';
			this.makeCode(this.identifyCodes, 4);
		},
		// 随机生成验证码字符串
		makeCode(data, len) {
			for (let i = 0; i < len; i++) {
				this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)];
			}
		},
		
	},

	data() {
		var checkTel = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			}
			var num_reg = /^13[0-9]{1}[0-9]{8}$|15[0-9]{1}[0-9]{8}$|16[0-9]{1}[0-9]{8}$|18[0-9]{1}[0-9]{8}|17[0-9]{1}[0-9]{8}$|19[0-9]{1}[0-9]{8}$|14[0-9]{1}[0-9]{8}/;
			if (!num_reg.test(value)) {
				callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		var checkVerificationCode = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('验证码不能为空'));
			}
			if (this.identifyCode.toLowerCase() != value.toLowerCase()) {
				callback(new Error('验证码错误'));
			} else {
				callback();
			}
		};
		return {
			canvasId:'s-canvas2',
			identifyCode: '',
			identifyCodes: [
				'0',
				'1',
				'2',
				'3',
				'4',
				'5',
				'6',
				'7',
				'8',
				'9',
				'A',
				'a',
				'B',
				'b',
				'C',
				'c',
				'D',
				'd',
				'E',
				'e',
				'F',
				'f',
				'G',
				'g',
				'H',
				'h',
				'I',
				'i',
				'J',
				'j',
				'K',
				'k',
				'L',
				'l',
				'M',
				'm',
				'N',
				'n',
				'O',
				'o',
				'P',
				'p',
				'Q',
				'q',
				'R',
				'r',
				'S',
				's',
				'T',
				't',
				'U',
				'u',
				'V',
				'v',
				'W',
				'w',
				'X',
				'x',
				'Y',
				'y',
				'Z',
				'z'
			], //根据实际需求加入自己想要的字符
			form: {
				contacts: '',
				tel: '',
				enterpriseName: '',
				job: '',
				source: '药销通官网',
				type: '1',
				yourRequirements: '',
				verificationCode: ''
			},
			rules: {
				enterpriseName: [{ required: true, message: '请输入公司名称', trigger: ['change', 'blur'] }],
				contacts: [{ required: true, message: '请输入联系人', trigger: ['change', 'blur'] }],
				tel: [{ validator: checkTel, trigger: ['change', 'blur'] }],
				verificationCode: [{ validator: checkVerificationCode, trigger: ['change', 'blur'] }]
			},
			imgUrl:require("@/assets/home/excessive.png"),
			formW:"559px",
			formH:"554px",
			screenheight: '558px'
		};
	}
};
</script>

<style lang="scss" scoped>
.yxtInfo {
	width: 100%;
	background: #2970ec;
	height: 594px;
	background-image: url("../../../assets/home/excessive.png");
	background-repeat: no-repeat;
	backdrop-filter: blur(4px);
}
.yxtInfo::before {
	content: '';
	display: table;
}
.content {
	height: 558px;
	position: relative;
	margin: 0 auto;
	width: $global-content-width;
	justify-content: space-between;
	align-items: center;
}
.left {
	// margin-top: 165px;
	.title {
		font-size: 34px;
		font-weight: 600;
		color: #ffffff;
		line-height: 48px;
	}
	.textInfo {
		margin-top: 23px;
		font-size: 26px;
		font-weight: 400;
		color: #ffffff;
		line-height: 37px;
	}
	.el-button {
		margin-top: 40px;
		width: 199px;
		height: 44px;
		color: #2970ec !important;
		background: #ffffff !important;
		border-radius: 4px;
		font-size: 18px;
	}
}
.right {
	width: 451px;
	min-height: 670px;
	position: absolute;
	top: -108px;
	right: 0;
	background: #ffffff;
	box-shadow: 0px 0px 22px 0px rgb(0 0 0 / 18%);
	border-radius: 8px;
}
.el-input__inner {
	height: 52px !important;
	line-height: 28px;
}
.el-input::v-deep {
	.el-input__inner {
		height: 52px;
		line-height: 52px;
		font-size: 14px !important;
	}
}
.el-form-item--mini.el-form-item {
	margin-bottom: 20px;
}
.form{
	.verificationCode {
		align-items: center;
		padding-top: 10px;
		width: 100%;
		height: 52px;
		border: 1px solid #dcdfe6;
	}
	.form-title-one{
		font-size: 18px;
		color: #2970EC;
	}
	.form-title-two{
		font-size: 14px;
		color: #333333;
	}
	.radio{
		padding-left: 80px !important;
	}
}
.form1 {
	justify-content: space-between;
	.el-form-item::v-deep {
		width: 49%;
	}
}
.el-form {
	margin: 0 auto;
	margin-top: 31px;
	width: 90%;
	p {
		line-height: 0;
		padding-left: 15px;
		font-size: 12px;
		color: #666666;
	}
	.el-button {
		height: 44px;
		width: 100%;
		background: #2970EC;
		border-radius: 2px;
	}
}
.hint {
	// margin-top: 48px;
	// margin-left: 40px;
	font-size: 18px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #2970ec;
	line-height: 25px;
}
.hint2 {
	margin-top: 15px;
	// margin-left: 40px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333333;
	line-height: 20px;
	margin-bottom: 30;
}
</style>
